import { MapContainer, TileLayer, Marker, Polyline, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useEffect } from "react";

const pin = (label, color) =>
  L.divIcon({
    className: "",
    html: `<div style="width:30px;height:30px;border-radius:999px;background:${color};color:#0b0f17;font:800 13px 'Barlow Condensed',sans-serif;display:flex;align-items:center;justify-content:center;border:2px solid #0b0f17;box-shadow:0 6px 16px rgba(0,0,0,.5)">${label}</div>`,
    iconSize: [30, 30],
    iconAnchor: [15, 15],
    popupAnchor: [0, -16],
  });

function FitBounds({ points }) {
  const map = useMap();
  useEffect(() => {
    if (!points.length) return;
    if (points.length === 1) map.setView(points[0], 13);
    else map.fitBounds(L.latLngBounds(points), { padding: [40, 40] });
  }, [map, points]);
  return null;
}

export default function RouteMap({ home, stops = [], showRoute = true, className = "h-[380px]" }) {
  const located = stops.filter((s) => s.lat != null && s.lng != null);
  const points = [...(home ? [[home.lat, home.lng]] : []), ...located.map((s) => [s.lat, s.lng])];
  if (!points.length) return null;
  const path = showRoute && home && located.length ? [[home.lat, home.lng], ...located.map((s) => [s.lat, s.lng]), [home.lat, home.lng]] : [];
  return (
    <div className={`rounded-2xl overflow-hidden border border-white/10 ${className}`} data-testid="route-map">
      <MapContainer center={points[0]} zoom={11} scrollWheelZoom={false} style={{ height: "100%", width: "100%", background: "#0b0f17" }}>
        <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" className="cj-dark-tiles" />
        <FitBounds points={points} />
        {home && (
          <Marker position={[home.lat, home.lng]} icon={pin("CJ", "#00f0ff")}>
            <Popup>{home.label}</Popup>
          </Marker>
        )}
        {located.map((s, i) => (
          <Marker key={s.id} position={[s.lat, s.lng]} icon={pin(s.order ?? i + 1, "#ff6b00")}>
            <Popup>
              <div style={{ fontFamily: "sans-serif", fontSize: 12 }}>
                <strong>{s.customer_name}</strong> · {s.scheduled_time}<br />{s.service_name}<br />{s.address}
                {s.geo_precision === "postcode" && <div style={{ color: "#b45309", marginTop: 4 }}>Approx. — postcode centre</div>}
              </div>
            </Popup>
          </Marker>
        ))}
        {path.length > 1 && <Polyline positions={path} pathOptions={{ color: "#ff6b00", weight: 3, dashArray: "6 8", opacity: 0.85 }} />}
      </MapContainer>
    </div>
  );
}
